import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class ProjectInfluencer extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showDraftModal = this.showDraftModal.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal   : false,
      targets : [],
      contract_info: {},
    };
  }
  // -------------------------------------------------------
  
  showDraftModal(targets) {
    this.setState({ modal: true, targets: targets });
  }
  // -------------------------------------------------------
  
  updateDraftStatus(update) {
    let detail = this.props.detail;
    
    let post_date = '';
    try { post_date = this.post_date.value; } catch(e) {}
    
    Utils.request.bind(this)('/api/project/influencer/draft_action', { project_id: this.props.data.project.id, targets: this.state.targets, post_date: post_date, is_remind: this.is_remind.checked },
      function(res){
        
        this.closeDraftModal.bind(this)();
        this.props.data.event.updateData('workflow', res.body.workflow);
        
      }.bind(this)
    );
    
  }
  // -------------------------------------------------------
  
  closeDraftModal() {
    this.setState({ modal: false, targets: [] });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    
    let influencers = [];
    this.state.targets.map((id) => {
      let inf = base.workflow.influencers[id];
      if( inf != undefined ){
        inf.contract_info = this.state.contract_info[id];
        influencers.push(inf);
      }
    });
    
    let buttons = [{ id: 'yes', name: 'はい', event: this.updateDraftStatus.bind(this)}, { id: 'no', name: 'いいえ' }];
    
    return (
      <div className="project-draft-setting-modal">
        <ContentsModal
          view      = {this.state.modal}
          width     = {600}
          height    = {480}
          close_ev  = {this.closeDraftModal.bind(this)}
          html      = {
            <div className="modal-item">
              <h2>下書きの作成をインフルエンサーに依頼しますか？</h2>
              
              <div className="influencer-box">
                { influencers.map((d, key) => {
                  return (
                    <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>@{d.insta_id}</Tooltip>}>
                      <img src={d.thumbnail} />
                    </OverlayTrigger>
                  );
                })}
              </div>
              
              <div className="date-box">
                <h5>下書きの提出日を設定する場合は、以下に日付を入力してください</h5>
                <input type="date" className="text" ref={(input) => { this.post_date = input }} />
                
                <div className="is-remind-box">
                  <div className="checkbox-frame">
                    <input type="checkbox" id="is_remind" className="checkbox" ref={(input) => { this.is_remind = input }} defaultChecked />
                    <label className="checkbox" htmlFor="is_remind">下書き提出日にDMでリマインドする（日付設定時のみ）</label>
                  </div>
                </div>
              </div>
              
              <div className="yes-no">
                { buttons.map((d, key) => {
                  if( d.html != undefined ) return React.cloneElement(d.html, { key: key });
                  
                  let event = d.event;
                  if( event == undefined ) event = this.closeDraftModal.bind(this);
                  return <div key={key} className={'button '+ d.id} onClick={event}>{d.name}</div>
                })}
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectInfluencer;